export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];


// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/formly/types/open-hours/weekdays.ts